<template>
  <f7-page name="garage">
    <bc-navbar></bc-navbar>
    <!-- Loader -->
    <div v-if="loading" class="loader">
      <looping-rhombuses-spinner
        :animation-duration="2500"
        :rhombus-size="15"
        color="#f9f300"
      />
    </div>
    <div class="content-wrapper">
      <!-- <a href="#" @click='back()'> 
        <img src="/static/images/icons/black/back.png" alt="" class="back_image_button" title="">
      </a> -->
      <h2 class="page_title">
        My Garage
      </h2>

      <div class="buttons-row">
        <a
          :href="'#' + purchasedTabName"
          class="tab-link button"
          :class="{ active: isTabActive(purchasedTabName) }"
          @click="onTab(purchasedTabName)"
          @openModal="openModal($event)"
          v-bind:style="[
            isTabActive(purchasedTabName)
              ? borderStyle
              : { 'background-color': '#fff', color: '#2196F3' },
          ]"
          >Purchased</a
        >
        <a
          :href="'#' + favoritesTabName"
          class="tab-link button"
          :class="{ active: isTabActive(favoritesTabName) }"
          @click="onTab(favoritesTabName)"
          v-bind:style="[
            isTabActive(favoritesTabName)
              ? borderStyle
              : { 'background-color': '#fff', color: '#2196F3' },
          ]"
          >My Favorites</a
        >
      </div>
      <div class="tabs-wrap">
        <div
          id="garageTabs"
          class="tabs"
         
        >
          <div
            :id="purchasedTabName"
            class="tab"
            :class="{ active: isTabActive(purchasedTabName) }">
            <garage-vehicles-list
              :vehicles="purchasedVehicles"
              :customization="customization"
              @scheduleService="openModal($event)"
              @whyMyCarWorth="openModal($event)"
              @onVehicleClick="onVehicleClick"
            ></garage-vehicles-list>
          </div>
          <div
            :id="favoritesTabName"
            class="tab"
            :class="{ active: isTabActive(favoritesTabName) }"
          >
            <garage-favorites-list
              :vehicles="favoritesVehicles"
              :customization="customization"
              :disableFavorite="disableFavorite"
              @toggleFavorite="onToggleVehicle($event)"
              @onVehicleClick="onVehicleClick"
            ></garage-favorites-list>
          </div>
        </div>
      </div>
    </div>
  <f7-popup ref="modal">
      <iframe id="widget" :src="widgetUrl" frameborder="0"></iframe>
  </f7-popup>
  </f7-page>
</template>

<script>
import { LoopingRhombusesSpinner } from 'epic-spinners'
import GarageVehiclesList from '../../components/garage/garage-vehicles-list.vue'
import GarageFavoritesList from '../../components/garage/garage-favorites-list.vue'
import { PAGES } from '../../shared/routes.constants'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'Garage',
  components: {
    LoopingRhombusesSpinner,
    'garage-vehicles-list': GarageVehiclesList,
    'garage-favorites-list': GarageFavoritesList
  },
  created () {
    // TODO: set active according route
    let route = this.$route
    if (route.path === PAGES.GarageFavorites) {
      this.activeTab = this.favoritesTabName
      this.getFavorites().finally(() => {
        this.loading = false
      })
    } else {
      this.activeTab = this.purchasedTabName
      this.getPurchased().finally(() => {
        this.loading = false
      })
    }
  },
  methods: {
    isTabActive (tabId) {
      return this.activeTab === tabId
    },
    back () {
      this.$router.back({
        reload: true
      })
    },
    onTab (tabname) {
      this.activeTab = tabname
      this.$router.load({
        url:
          this.activeTab === this.favoritesTabName
            ? PAGES.GarageFavorites
            : PAGES.GaragePurchased
      })
    },
    ...mapActions({
      getPurchased: 'garage/loadPurchased',
      getFavorites: 'garage/loadFavorites',
      toggleFavorite: 'garage/toggleFavorite'
    }),
    onToggleVehicle ({contactVehicleId, vehicleId}) {
      this.disableFavorite = true
      this.toggleFavorite({contactVehicleId, vehicleId, isFavorite: false}).finally(_ => {
        this.disableFavorite = false
      })
    },
    onVehicleClick ({vehicleId}) {
      this.$router.load({
        url: PAGES.VehicleDetails(vehicleId)
      })
    },
    openModal (url) {
      this.widgetUrl = url
      this.$refs.modal.open()
      this.listenModalMessage()
    },
    listenModalMessage () {
      window.onmessage = (e) => {
        if (e.data === 'close') {
          this.$refs.modal.close()
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      purchasedVehicles: 'garage/purchased',
      favoritesVehicles: 'garage/favorites'
    }),
    ...mapState({
      customization: (state) => state.common.customization
    }),
    borderStyle: function () {
      var borderStyle = this.customization.borderOn
        ? 'solid 1px ' + this.customization.borderColor
        : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    }
  },
  data () {
    return {
      loading: true,
      purchasedTabName: 'purchased',
      favoritesTabName: 'favorites',
      activeTab: null,
      widgetUrl: null,
      disableFavorite: false
    }
  }
}
</script>

<style scoped>
.content-wrapper {
  width: 100%;
  box-sizing: border-box;
  padding: 0 5%;
}
.buttons-row {
  margin: 0 -5%;
}
.loader {
  position: fixed;
  z-index: 1;
  background: rgb(255, 255, 255);
}
.tabs-wrap {
  padding: 20px 0;
}
#widget{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// garage.vue?29a2a72d